import { ContentfulAuthor } from '@jbhi-fi/apis/src/contentful/types';
import { UserProfileProps } from '../../UserProfile/UserProfile';

export abstract class AuthorTransformer {
  static toUserProfileProps = ({ fields }: ContentfulAuthor): UserProfileProps => {
    return {
      name: fields?.name ?? '',
      position: fields?.title ?? '',
      photoSrc: fields?.profilePicture?.fields
        ? `${fields?.profilePicture?.fields?.file.url}?w=128&h=128&fit=pad&bg=rgb:FFEC0F`
        : '',
    };
  };
}
